import { useContext } from 'react';
import UnmappedContext from "../UnmappedContext.js";
export var useFilteredResults = () => {
  var ctx = useContext(UnmappedContext);
  return ctx.store.filteredResults.results;
};
export default useFilteredResults;
//# sourceMappingURL=useFilteredResults.js.map